export enum TransactionType {
	POS = 1,
	ONLINEORDER = 2,
	EGIFT = 3,
	KIOSK = 4,
}
